import { Grid, MenuItem, TextField } from "@mui/material";
import { useEffect } from "react";

const PersonalInfoStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])
    
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Name"
                    id="outlined-size-small"
                    name="name"
                    value={props.formData.name}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('name') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('name')}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Surname"
                    id="outlined-size-small"
                    name="surname"
                    value={props.formData.surname}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('surname') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('surname')}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Phone"
                    id="outlined-size-small"
                    name="phone"
                    value={props.formData.phone}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('phone') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('phone')}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Email"
                    id="outlined-size-small"
                    name="email"
                    value={props.formData.email}
                    size="small"
                    fullWidth
                    type="email"
                    helperText={props.emailError !== '' ? props.emailError : props.emptyFormProps.includes('email') ? 'This field is required' : ''}
                    error={!!props.emailError || !!props.emptyFormProps.includes('email')}
                    onBlur={props.handleEmailBlur}
                    onChange={e => props.handleInputChange(e)}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Current employer (if retired, please note here)"
                    id="outlined-size-small"
                    name="institution"
                    value={props.formData.institution}
                    defaultValue=""
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('institution') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('institution')}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    label="Job title"
                    id="outlined-size-small"
                    name="job_title"
                    value={props.formData.job_title}
                    size="small"
                    fullWidth
                    helperText={props.emptyFormProps.includes('job_title') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('job_title')}
                    onChange={e => props.handleInputChange(e)}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <TextField
                    id="outlined-select-country"
                    name="country"
                    select
                    label="Country"
                    value={props.formData.country}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('country') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('country')}
                >
                    {props.countryOptions.map((option) => (
                        <MenuItem sx={{ '& > img': { mr: 2, flexShrink: 0 } }} key={option.value} value={option.value}>
                            <img
                                loading="lazy"
                                width="20"
                                srcSet={option.flag}
                                src={option.flag}
                                alt=""
                            />
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    )
}

export default PersonalInfoStep;